/**
 * Central background asset configuration — the single place the UI resolves
 * background images and the login video from.
 *
 * HOW TO CHANGE A BACKGROUND (single edit point):
 *   1. Drop the new asset into `src/images` (image) or `src/videos` (video).
 *   2. Update the matching `file` in `backgroundConfig.json`.
 *   3. Keep within the `sizeLimits` in that file (checked by BackgroundConfig.test).
 * Components read from here, so no other source file needs editing.
 */
import config from './backgroundConfig.json';
// Resolve a configured file name to its bundled asset URL. A missing file
// surfaces as an error at load time, and BackgroundConfig.test guards it in CI.
const resolveAsset = (file) => /\.mp4$/i.test(file) ? require('../videos/' + file) : require('../images/' + file);
const build = (surface) => ({
    url: resolveAsset(surface.file),
    file: surface.file,
    description: surface.description,
});
export const sizeLimits = config.sizeLimits;
const backgroundAssets = {
    chatBackground: build(config.surfaces.chatBackground),
    loginBackground: build(config.surfaces.loginBackground),
    loginVideo: build(config.surfaces.loginVideo),
};
export default backgroundAssets;
